const STATUS_STYLES = {
  draft: {
    background: 'grey',
    color: '#fff',
    borderRadius: '4px',
    padding: '2px 8px',
  },
  published: {
    background: 'green',
    color: '#fff',
    borderRadius: '4px',
    padding: '2px 8px',
  },
  coming_soon: {
    background: '#5B9BFF',
    color: '#fff',
    borderRadius: '4px',
    padding: '2px 8px',
  },
  unpublished: {
    background: 'orange',
    color: '#fff',
    borderRadius: '4px',
    padding: '2px 8px',
  },
}

const TYPE_STYLES = {
  Major: {
    background: '#FDEDEA',
    color: '#F26B5E',
    borderRadius: '4px',
    padding: '2px 8px',
  },
  Minor: {
    background: '#EEF5FF',
    color: '#5B9BFF',
    borderRadius: '4px',
    padding: '2px 8px',
  },
}

export const CERT_VERSION_STYLES = {
  CertificationVersionHistory: {
    status: STATUS_STYLES,
    type: TYPE_STYLES,
  },
}

export const CERT_LIST_STYLES = {
  CertificationVersions: {
    status: STATUS_STYLES,
  },
}

export const CERTIFICATION_STATUS_OPTIONS = [
  { label: 'Draft', value: 'draft' },
  { label: 'Published', value: 'published' },
  { label: 'Unpublished', value: 'unpublished' },
]

export const LAUNCH_CONFIGURATION_PHASE_OPTIONS = [
  { label: 'Pre-sale', value: 'pre_sale' },
  { label: 'Public sale', value: 'public_sale' },
]

export const CERTIFICATION_VOUCHER_FIELD_MAPPINGS = [
  { formKey: 'maxAttempts', errorKey: 'max_attempts' },
  {
    formKey: 'nextAttemptTime',
    errorKey: 'time_after_first_attempt_in_minutes',
  },
  { formKey: 'validForInDays', errorKey: 'valid_for_in_days' },
]

export const CERTIFICATION_FORM_ACTION_LABELS = {
  CREATE_AS_DRAFT: 'Create as Draft',
  CREATING: 'Creating certification...',
  SAVE: 'Save certification',
  SAVING: 'Saving certification...',
}

export const CERTIFICATION_IDENTITY_VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'Name is required.',
  SHORT_NAME_REQUIRED: 'Short Name is required.',
  LEARNING_AREA_REQUIRED: 'Learning Area is required.',
}
